import React from "react";
import { defaultFeatureFlags, IFlavor } from "./flavorTypes";
import { LogoNewAiFi } from "../../components/LogoNewAiFi";
import { timezoneDate } from "../utils";
import { IFeatureFlags } from "../../../../shared/interface";

export abstract class Flavor implements IFlavor {
  getIconColor(): string {
    return this.getMainColor();
  }

  getSpinnerColor(): string {
    return this.getMainColor();
  }

  getDashLineColor(): string {
    return this.getMainColor();
  }

  getFeatureFlags(): IFeatureFlags {
    return defaultFeatureFlags;
  }

  getCircleLogo(): JSX.Element {
    return <LogoNewAiFi />;
  }

  getReceiptLogo() {
    return this.getCircleLogo()
  }

  getFontFamily(): string {
    return 'Montserrat';
  }

  formatDateTime(dateTime: string, timezone: string): { date: string; time: string } {
    const date = timezoneDate(dateTime, timezone)
    const formatDate = "DD MMM YYYY";
    const formatTime = "hh:mma";

    return {
      date: date.format(formatDate),
      time: date.format(formatTime),
    };
  }

  formatTableDateTime(dateTime: string, timezone: string): { date: string; time: string } {
    const date = timezoneDate(dateTime, timezone)
    const formatDate = "DD/M/YY";
    const formatTime = "hh:mma";

    return {
      date: date.format(formatDate),
      time: date.format(formatTime),
    };
  }

  abstract getMainColor(): string;
}
